<template>
  <nav
    class="md:left-0 md:block md:fixed md:top-0 md:bottom-0 md:overflow-y-auto md:flex-row md:flex-nowrap md:overflow-hidden shadow-xl bg-white flex flex-wrap items-center justify-between relative md:w-64 z-10 py-4 px-6"
  >
    <div
      class="md:flex-col md:items-stretch md:min-h-full md:flex-nowrap px-0 flex flex-wrap items-center justify-between w-full mx-auto"
    >
      <!-- Toggler -->
      <button
        class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
        type="button"
      >
        <i class="fas fa-bars"></i>
      </button>
      <!-- Brand -->
      <router-link
        class="md:flex md:justify-center md:pb-2 text-blue-600 mr-0 inline-block px-0"
        :to="{ name: 'Dashboard' }"
      >
        <img src="@/assets/musicverse-logo.png" class="w-1/3" />
      </router-link>
      <!-- User -->
      <ul class="md:hidden items-center flex flex-wrap list-none">
        <li class="inline-block relative">
          <user-dropdown />
        </li>
      </ul>
      <!-- Collapse -->
      <div
        class="md:flex md:flex-col md:items-stretch md:opacity-100 md:relative md:mt-0 md:shadow-none shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto items-center flex-1 rounded"
        v-bind:class="collapseShow"
      >
        <!-- Collapse header -->
        <div
          class="md:min-w-full md:hidden block pb-4 mb-4 border-b border-solid border-blueGray-200"
        >
          <div class="flex flex-wrap">
            <div class="w-6/12">
              <router-link
                class="md:block text-left md:pb-2 text-blue-600 mr-0 inline-block whitespace-nowrap text-sm uppercase font-bold p-4 px-0"
                :to="{ name: 'Dashboard' }"
              >
                <img src="@/assets/musicverse-logo.png" class="w-full" />
              </router-link>
            </div>
            <div class="w-6/12 flex justify-end">
              <button
                type="button"
                class="cursor-pointer text-black opacity-50 md:hidden px-3 py-1 text-xl leading-none bg-transparent rounded border border-solid border-transparent"
                v-on:click="toggleCollapseShow('hidden')"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
        </div>
        <!-- Form -->

        <!-- Divider -->
        <hr class="my-4 md:min-w-full" />
        <!-- Navigation -->
        <h6
          class="md:min-w-full text-gray-600 text-xs text-left uppercase font-bold block pt-1 pb-4 no-underline"
        >
          Menu Navigation
        </h6>
        <ul class="md:flex-col md:min-w-full flex flex-col list-none">
          <li class="items-center" v-if="!isReviewer && !isRecruitment && !isFinance">
            <router-link
              :to="{ name: 'Statistic' }"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-sm uppercase py-3 font-bold block text-left"
                :class="[
                  currentRoute === 'Statistic'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
              >
                <i
                  class="fas fa-chart-line mr-2 text-sm"
                ></i>
                <span class="text-xs">Home</span>
              </a>
            </router-link>
          </li>

          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link
              :to="{ name: 'AdsSettings' }"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-sm uppercase py-3 font-bold block text-left"
                :class="[
                  isAppSettingMenu
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
              >
                <i
                  class="fa fa-cog mr-2 text-sm"
                ></i>
                <span class="text-xs">App Settings</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isAppSettingMenu">
              <li class="items-center">
                <router-link
                  :to="{ name: 'AdsSettings' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                      currentRoute === 'AdsSettings'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',
                    ]"
                  >
                    <span class="text-xs">Ads</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link
                  :to="{ name: 'AccountDeletionSurvey' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                  currentRoute === 'AccountDeletionSurvey'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
                  >
                    <span class="text-xs">Account Deletion Survey</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link
                  :to="{ name: 'HomeSection' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                  currentRoute === 'HomeSection'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
                  >
                    <span class="text-xs">Home Section</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link
                  :to="{ name: 'OnboardingBanner' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                  currentRoute === 'OnboardingBanner'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
                  >
                    <span class="text-xs">Onboarding Banner</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link
                  :to="{ name: 'ReferralBanner' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                  currentRoute === 'ReferralBanner'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
                  >
                    <span class="text-xs">Referral Banner</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link
                  :to="{ name: 'ReferralAbout' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                  currentRoute === 'ReferralAbout'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
                  >
                    <span class="text-xs">Referral About</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link
              :to="{ name: 'MusicCategoriesPage' }"
              v-slot="{ href, navigate, isActive }"
            >
              <a
                :href="href"
                @click="navigate"
                class="text-sm uppercase py-3 font-bold block text-left"
                :class="[
                  isCategoriesMenu
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
              >
                <i
                  class="fa fa-list-ul mr-2 text-sm"
                ></i>
                <span class="text-xs">Categories</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isCategoriesMenu">
              <li class="items-center">
                <router-link
                  :to="{ name: 'MusicCategoriesPage' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                      currentRoute === 'MusicCategoriesPage'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',
                    ]"
                  >
                    <span class="text-xs">Music Categories</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link
                  :to="{ name: 'MissionCategoriesPage' }"
                  v-slot="{ href, navigate, isActive }"
                >
                  <a
                    :href="href"
                    @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                  currentRoute === 'MissionCategoriesPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',
                ]"
                  >
                    <span class="text-xs">Missions Videos Categories</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link to="/missions-videos" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                class="text-sm uppercase py-3 font-bold block text-left"
                :class="[ isMissionsVideosMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fas fa-video mr-2 text-sm"></i><span class="text-xs">Missions Videos</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isMissionsVideosMenu">
              <li class="items-center">
                <router-link :to="{ name: 'ChannelListPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                      currentRoute === 'ChannelListPage'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Channel List</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'RecommendedVideosPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                    class="text-sm uppercase py-3 font-bold block text-left"
                    :class="[
                  currentRoute === 'RecommendedVideosPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Recommended Video</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'VideoPageSection' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'VideoPageSection' || currentRoute === 'VideoPageDetail'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Video Page</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isAdmin || isSuperAdmin || isReviewer">
            <router-link :to="{ name: 'ListPlaylist' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isPlaylistMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fas fa-play-circle mr-2 text-sm"></i><span class="text-xs">Playlist</span>
              </a>
            </router-link>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'Users' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isUserMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-users mr-2 text-sm"></i><span class="text-xs">Users</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isUserMenu">
              <li class="items-center">
                <router-link :to="{ name: 'Users' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'Users'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">App Users</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'UsersAdmin' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'UsersAdmin'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Admin Users</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'UsersDeletedPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'UsersDeletedPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Deleted App Users</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin || isRecruitment">
            <router-link :to="{ name: 'Artists' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isArtistManagementMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-drum mr-2 text-sm"></i><span class="text-xs">Artists</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isArtistManagementMenu">
              <li class="items-center">
                <router-link :to="{ name: 'Artists' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'Artists' || currentRoute === 'DetailArtistPage' || currentRoute === 'AddArtistPage'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Artist List</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'DraftArtistPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                   currentRoute === 'DraftArtistPage'
                     ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                     : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Draft</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'ArtistOnboardingPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                   currentRoute === 'ArtistOnboardingPage' || currentRoute === 'ArtistApplicationDetailPage'
                     ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                     : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Onboarding</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="!isFinance">
            <router-link :to="{ name: isArtist? 'Album' : 'SongManagement' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isAlbumMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-music mr-2 text-sm"></i><span class="text-xs">Content</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isAlbumMenu">
              <li class="items-center" v-if="!isArtist">
                <router-link :to="{ name: 'SongManagement' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'SongManagement'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Songs</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'Album' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'Album'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Album</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center" v-if="!isArtist">
                <router-link :to="{ name: 'ArtistsBio' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'ArtistsBio'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Bio</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isArtist">
            <router-link :to="{ name: 'PurchaseListPage' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isTransactionsMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fas fa-chart-bar mr-2 text-sm"></i><span class="text-xs">Transactions</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isTransactionsMenu">
              <li class="items-center">
                <router-link :to="{ name: 'StreamListPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'StreamListPage'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Stream</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'Transactions' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'Transactions'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Purchase</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'EarningPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'EarningPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Earnings</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'TncManagement' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ currentRoute === 'TncManagement' ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fas fa-file-contract mr-2 text-sm"></i><span class="text-xs">Term of Service</span>
              </a>
            </router-link>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'CreditsAmount' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isPricingMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fas fa-money-bill mr-2 text-sm"></i><span class="text-xs">Pricing</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isPricingMenu">
              <li class="items-center">
                <router-link :to="{ name: 'CreditsAmount' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'CreditsAmount'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Credits Amount</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'SubscriptionSettingPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'SubscriptionSettingPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Subscription</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'IapManagement' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'IapManagement'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">In-App Purchase</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'TransactionHistoryPage' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isTransactionsAdminMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fas fa-clipboard-list mr-2 text-sm"></i><span class="text-xs">Transactions</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isTransactionsAdminMenu">
              <li class="items-center">
                <router-link :to="{ name: 'TransactionHistoryPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'TransactionHistoryPage'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Content Purchase</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'CreditPurchasePage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'CreditPurchasePage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Credit Purchase</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'SubscriptionHistoryPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'SubscriptionHistoryPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Subscription</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'RedemptionHistoryPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'RedemptionHistoryPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Redemption</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="!isArtist && !isRecruitment && !isReviewer">
            <router-link :to="{ name: 'PayoutList' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isFinanceMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-chart-bar mr-2 text-sm"></i><span class="text-xs">Finance</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isFinanceMenu">
              <li class="items-center">
                <router-link :to="{ name: 'PayoutList' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'PayoutList'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Payout List</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'PayoutDashboard' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'PayoutDashboard'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Payout Dashboard</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'TransferHistory' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'TransferHistory'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Transfer History</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'RatingList' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isRatingSurveyMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-star mr-2 text-sm"></i><span class="text-xs">Rating and Survey</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isRatingSurveyMenu">
              <li class="items-center">
                <router-link :to="{ name: 'RatingList' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'RatingList'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Ratings</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'SurveyList' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'SurveyList'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Survey</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'ReferralDataBannerPage' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isReferralDataMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-users mr-2 text-sm"></i><span class="text-xs">Referral Data</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isReferralDataMenu">
              <li class="items-center">
                <router-link :to="{ name: 'ReferralDataBannerPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'ReferralDataBannerPage'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Banner Click</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'ReferralDataSharePage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'ReferralDataSharePage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Share Click</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'ReferralDataMemberPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'ReferralDataMemberPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Referred Member</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isOps || isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'FirstTimeSubsPage' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ isSubscriptionMenu ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-users mr-2 text-sm"></i><span class="text-xs">Subscription</span>
              </a>
            </router-link>
            <ul class="md:flex-col md:min-w-full flex flex-col list-none ml-5" v-if="isSubscriptionMenu">
              <li class="items-center">
                <router-link :to="{ name: 'FirstTimeSubsPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                      currentRoute === 'FirstTimeSubsPage'
                        ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                        : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">First Time</span>
                  </a>
                </router-link>
              </li>
              <li class="items-center">
                <router-link :to="{ name: 'CancelExpireSubsPage' }" v-slot="{ href, navigate, isActive }">
                  <a :href="href" @click="navigate"
                     class="text-sm uppercase py-3 font-bold block text-left"
                     :class="[
                  currentRoute === 'CancelExpireSubsPage'
                    ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800'
                    : 'text-gray-800 hover:text-gray-600',]">
                    <span class="text-xs">Cancel & Expire</span>
                  </a>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="items-center" v-if="isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'CLTVPage' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ currentRoute === 'CLTVPage' ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-users mr-2 text-sm"></i><span class="text-xs">CLTV</span>
              </a>
            </router-link>
          </li>
          <li class="items-center" v-if="isAdmin || isSuperAdmin">
            <router-link :to="{ name: 'UsersPremium' }" v-slot="{ href, navigate, isActive }" >
              <a :href="href" @click="navigate"
                 class="text-sm uppercase py-3 font-bold block text-left"
                 :class="[ currentRoute === 'UsersPremium' ? 'text-blue-700 hover:text-blue-500 border-b-2 border-gray-800' : 'text-gray-800 hover:text-gray-600',]"
              >
                <i class="fa fa-crown mr-2 text-sm"></i><span class="text-xs">Premium Users</span>
              </a>
            </router-link>
          </li>
        </ul>

        <!-- Divider -->
<!--        <hr class="my-4 md:min-w-full" />-->
        <!-- Heading -->
      </div>
    </div>
  </nav>
</template>

<script>
import UserDropdown from '@/components/Layout/UserDropdown';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'SideBar',
  data() {
    return {
      collapseShow: 'hidden',
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['isLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['accessToken', 'isArtist', 'isSuperAdmin', 'isOps',
      'isRecruitment', 'isReviewer', 'isFinance', 'tokenType', 'isAdmin',
      'getName', 'isUpdateTnc', 'getUser']),
    currentRoute() {
      return this.$route.name;
    },
    isAlbumMenu() {
      return this.currentRoute === 'Album' || this.currentRoute === 'SongManagement' || this.currentRoute === 'ArtistsBio';
    },
    isArtistManagementMenu() {
      return this.currentRoute === 'Artists' || this.currentRoute === 'AddArtistPage' || this.currentRoute === 'DetailArtistPage' || this.currentRoute === 'DraftArtistPage' || this.currentRoute === 'ArtistOnboardingPage' || this.currentRoute === 'ArtistApplicationDetailPage';
    },
    isFinanceMenu() {
      return this.currentRoute === 'PayoutList' || this.currentRoute === 'PayoutDashboard' || this.currentRoute === 'TransferHistory';
    },
    isUserMenu() {
      return this.currentRoute === 'Users' || this.currentRoute === 'UsersAdmin' || this.currentRoute === 'UsersDeletedPage'
        || this.currentRoute === 'SubscriptionVerifyStudentPage' || this.currentRoute === 'SubscriptionVerifyStudentHistoryPage';
    },
    isTransactionsMenu() {
      return this.currentRoute === 'Transactions' || this.currentRoute === 'Report'
        || this.currentRoute === 'StreamListPage' || this.currentRoute === 'PurchaseListPage' || this.currentRoute === 'EarningPage';
    },
    isTransactionsAdminMenu() {
      return this.currentRoute === 'TransactionHistoryPage'
        || this.currentRoute === 'CreditPurchasePage'
        || this.currentRoute === 'SubscriptionHistoryPage'
        || this.currentRoute === 'RedemptionHistoryPage'
      ;
    },
    isPricingMenu() {
      return this.currentRoute === 'SubscriptionSettingPage' || this.currentRoute === 'CreditsAmount' || this.currentRoute === 'IapManagement';
    },
    isAppSettingMenu() {
      const listPage = ['DailyPremiumAccessPage', 'AdsSettings', 'SkipQuotaSettings', 'AccountDeletionSurvey','HomeSection','HomeSectionDetail','OnboardingBanner','ReferralBanner', 'ReferralAbout'];
      return listPage.includes(this.currentRoute);
    },
    isPlaylistMenu() {
      const listPage = ['ListPlaylist', 'AddPlaylist', 'EditPlaylist'];
      return listPage.includes(this.currentRoute);
    },
    isRatingSurveyMenu() {
      const listPage = ['RatingList', 'SurveyList'];
      return listPage.includes(this.currentRoute);
    },
    isMissionsVideosMenu() {
      const listPage = ['ChannelListPage','ChannelDetailPage','RecommendedVideosPage','VideoPageSection','VideoPageDetail'];
      return listPage.includes(this.currentRoute);
    },
    isCategoriesMenu() {
      const listPage = ['MusicCategoriesPage','MissionCategoriesPage'];
      return listPage.includes(this.currentRoute);
    },
    isReferralDataMenu() {
      const listPage = ['ReferralDataBannerPage','ReferralDataSharePage','ReferralDataMemberPage'];
      return listPage.includes(this.currentRoute);
    },
    isSubscriptionMenu() {
      const listPage = ['FirstTimeSubsPage','CancelExpireSubsPage'];
      return listPage.includes(this.currentRoute);
    },
    isCLTVMenu() {
      const listPage = ['CLTVPage'];
      return listPage.includes(this.currentRoute);
    },
  },
  methods: {
    toggleCollapseShow(classes) {
      this.collapseShow = classes;
    },
  },
  components: { UserDropdown },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Layout/SideBar.vue